import { Curl } from "components/Jarvis";
const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const searchSettlementData = (data) => {
  return Curl.get(`/payplus/settlement/search${data}`).then((res) => res);
};

export const getSettlementTransaction = (settlementID) => {
  return Curl.get(`/payplus/settlement/transaction/get/${settlementID}`).then(
    (res) => res
  );
};

export const getSettlementPayments = (paymentID) => {
  return Curl.get(`/payplus/gateway/resources/payments/${paymentID}`).then(
    (res) => res
  );
};

export const deleteSettlementTransaction = (id) => {
  return Curl.post(`/payplus/settlement/transaction/delete`, id).then(
    (res) => res
  );
};
export const updateSettlementStatus = (id) => {
  return Curl.post(`/payplus/settlement/status/update`, id).then((res) => res);
};
export const updateSettlementAdjustment = (data) => {
  return Curl.post(`/payplus/settlement/adjustment`, data).then((res) => res);
};

export const getTimeRangeSettlement = (fromdate, todate) => {
  if (!fromdate || !todate) {
    const newData = {
      timezone: timezone,
      fromdate: 90,
      todate: null,
    };
    return Curl.post(
      `/payplus/settlement/get-time-range-settlement`,
      newData
    ).then((res) => {
      return res;
    });
  } else {
    const newData = {
      timezone: timezone,
      fromdate: fromdate,
      todate: todate,
    };
    return Curl.post(
      `/payplus/settlement/get-time-range-settlement`,
      newData
    ).then((res) => {
      return res;
    });
  }
};

export const getSettlementSummary = () => {
  return Curl.post(`/payplus/settlemenmt/summary`, { timezone: timezone }).then(
    (res) => {
      return res;
    }
  );
};

export const getSettlementReceipt = (id) => {
  return Curl.get(`/payplus/settlement/${id}/receipt?print=false`).then(
    (res) => {
      return res;
    }
  );
};
